import { EmployeeAttendanceMonthlySummaryDto } from './employee-attendance-monthly-summary-dto.model';
import { ApiErrorCode } from '../service-proxies';


export class EmployeeAttendanceMonthlySummaryDtoListApiResponse implements IEmployeeAttendanceMonthlySummaryDtoListApiResponse {
    isSuccess!: boolean;
    responseData!: EmployeeAttendanceMonthlySummaryDto[] | undefined;
    errorCode!: ApiErrorCode;
    errorMessage!: string | undefined;
    errorTitle!: string | undefined;

    constructor(data?: IEmployeeAttendanceMonthlySummaryDtoListApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(EmployeeAttendanceMonthlySummaryDto.fromJS(item));
            }
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorTitle = _data["errorTitle"];
        }
    }

    static fromJS(data: any): EmployeeAttendanceMonthlySummaryDtoListApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAttendanceMonthlySummaryDtoListApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item.toJSON());
        }
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorTitle"] = this.errorTitle;
        return data; 
    }
}

export interface IEmployeeAttendanceMonthlySummaryDtoListApiResponse {
    isSuccess: boolean;
    responseData: EmployeeAttendanceMonthlySummaryDto[] | undefined;
    errorCode: ApiErrorCode;
    errorMessage: string | undefined;
    errorTitle: string | undefined;
}

